
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import PaginaInformativa, { Sezione } from '../components/PaginaInformativa';
Contatti.paginaPubblica = true;
export default function Contatti() {
    return (<PaginaInformativa titolo="Contatti" sottotitolo="Come raggiungere chi cura questo ambiente dimostrativo.">
      <p>
        Dimora è curato da Giuseppe Delli Paoli. L&apos;ambiente che stai
        guardando è una demo pubblica: per provare il prodotto non serve
        scrivere a nessuno, basta il bottone &laquo;Prova la demo&raquo;.
      </p>

      <Sezione titolo="Vuoi un account?">
        <p>
          Le registrazioni libere sono chiuse: gli account vengono creati su
          invito. Scrivi a{' '}
          <a href="mailto:giuseppe.dellipaoli@dimora.test" className="font-medium text-primary hover:underline">
            giuseppe.dellipaoli@dimora.test
          </a>{' '}
          indicando quanti immobili gestisci: riceverai le credenziali di un
          ambiente dedicato.
        </p>
      </Sezione>

      <Sezione titolo="Segnalazioni">
        <p>
          Hai trovato un errore o qualcosa che non torna nella demo? Una
          segnalazione allo stesso indirizzo è il modo più rapido per farla
          arrivare a destinazione.
        </p>
      </Sezione>
    </PaginaInformativa>);
}

    async function __Next_Translate__getStaticProps__19fd5e3c68a__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/contatti',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19fd5e3c68a__ as getStaticProps }
  